import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 登入
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/Login/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // routeTo.params.breadcrumbTitle = '會員登入';
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLogoutPage: true,
      title: '登入'
    },
  },
  // 綁定 Line帳號
  {
    path: '/account-bind',
    name: 'line-bind',
    component: () => lazyLoadView(import('@views/Login/Line')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // routeTo.params.breadcrumbTitle = '會員登入';
          await store.dispatch('global/fetchSetting')
          if (!store.state.global.currentSetting?.liffId) {

            alert('LIFF錯誤，無法登入 \n 系統將重新導向至首頁');
            return next({ name: 'home' })
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '綁定Line帳號'
    },
  },
  // BotBonnie登入入口
  {
    path: '/botbonnie-login',
    name: 'botbonnie-login',
    component: () => lazyLoadView(import('@views/Login/BotBonnie')),
    meta: {
      title: 'BotBonnie登入'
    },
  },
  // 舊會員資料更新
  {
    path: '/member/update/:uuid',
    name: 'member-update',
    component: () => lazyLoadView(import('@views/MemberUpdate/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (store.getters['auth/loggedIn']) {
            await store.dispatch('auth/logOut')
          }
          const { uuid } = routeTo.params
          routeTo.params.defaultValue = await store.dispatch('auth/fetchUserByUUID', uuid)
          // routeTo.params.breadcrumbTitle = '會員資料更新';
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '舊會員資料更新'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    })
  },
  // 註冊
  /* {
  path: '/registered',
  name: 'registered',
  component: () => lazyLoadView(import('@views/Login/Index')),
  meta: {
  async beforeResolve(routeTo, routeFrom, next) {
  try {
  routeTo.params.breadcrumbTitle = '會員註冊';
  next()
  } catch (error) {
  routeError(error, routeTo, next({ name: '404' }));
  }
  },
  isLogoutPage: true
  },
   }, */
]


